// COMPONENT
import { componentModalInterstitial } from './components/modal/modal-interstitial';

// Initialize your application
document.addEventListener('DOMContentLoaded', () => {
    componentModalInterstitial();
});